import { render, staticRenderFns } from "./IncomeStats.vue?vue&type=template&id=5b06ec82&lang=pug&"
import script from "./IncomeStats.vue?vue&type=script&lang=ts&"
export * from "./IncomeStats.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeStats.vue?vue&type=style&index=0&id=5b06ec82&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports